import { BrowserRouter, Route, Routes } from 'react-router-dom';

import 'notifications/handlers';
import { Analytics } from 'analytics/components';
import { Error, Notification } from 'core/components';
import { NotificationPosition } from 'core/enums';
import { NotificationProvider } from 'core/states';
import { BellNotificationsProvider, NotificationHost } from 'notifications';
import { CleanState, PrivateRoute } from 'router/components';
import { BASE_ROUTE } from 'router/constants';
import { routes } from 'router/routes';

import { VersionedRoute } from './VersionedRoute';

const Router = () => {
  return (
    <BrowserRouter basename={BASE_ROUTE}>
      <CleanState>
        <NotificationProvider>
          <BellNotificationsProvider>
            <>
              <Notification position={NotificationPosition.TOP} />
              <NotificationHost />

              <Routes>
                {routes.map((route) => {
                  if (route.isPrivate) {
                    route.element = <PrivateRoute path={route?.path}>{route.element}</PrivateRoute>;
                  }

                  route.element = <VersionedRoute path={route.path} element={route.element} />;

                  return (
                    <Route key={route.path} {...route}>
                      {route?.nestedRoutes?.map((item) => <Route key={item.path} {...item} />)}
                    </Route>
                  );
                })}

                <Route path="*" element={<Error />} />
              </Routes>
            </>
          </BellNotificationsProvider>
        </NotificationProvider>
        <Analytics />
      </CleanState>
    </BrowserRouter>
  );
};

export default Router;
